import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FETCH_ASSETS_URL } from 'appenv';

import BannerCarousel from './v2/BannerCarousel';

const tvBackgroundSrc = `${FETCH_ASSETS_URL}/assets/tv.png`;
const tvV2BackgroundSrc = `${FETCH_ASSETS_URL}/assets/tv_v2.png`;

const GenericBannerContainer = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  width: ${({ width }) => width}%;
  height: ${({ height }) => (height !== 0 ? `${height}%` : 'auto')};
  top: ${({ top }) => top !== 0 && top}%;
  left: ${({ left }) => left !== 0 && left}%;
  right: ${({ right }) => right !== 0 && right}%;
  bottom: ${({ bottom }) => bottom !== 0 && bottom}%;
  transform:
    ${(props) => {
    const styles = [
      { key: 'translateX', unit: '%' },
      { key: 'translateY', unit: '%' },
      { key: 'skewX', unit: 'deg' },
      { key: 'skewY', unit: 'deg' },
      { key: 'scaleX', unit: '' },
      { key: 'scaleY', unit: '' },
    ];

    if (!props.isSafari) {
      styles.push({ key: 'rotateY', unit: 'deg' });
      styles.push({ key: 'rotateX', unit: 'deg' });
    }

    return styles
      .filter(({ key }) => props[key])
      .map(({ key, unit }) => `${key}(${props[key]}${unit})`)
      .join(' ');
  }} !important;
`;

const SliderContainer = styled.div`
  position: absolute;
  width:
    ${({ isTv, tvType }) => {
    if (isTv) {
      switch (tvType) {
        case 0:
          return 94.5;
        case 1:
        default:
          return 100;
      }
    } else {
      return 100;
    }
  }}%;
  height:
    ${({ isTv, tvType }) => {
    if (isTv) {
      switch (tvType) {
        case 0:
          return 90;
        case 1:
        default:
          return 94;
      }
    } else {
      return 100;
    }
  }}%;
  top:
    ${({ isTv, tvType }) => {
    if (isTv) {
      switch (tvType) {
        case 0:
          return 6;
        case 1:
        default:
          return 3;
      }
    } else {
      return 0;
    }
  }}%;
  left:
    ${({ isTv, tvType }) => {
    if (isTv) {
      switch (tvType) {
        case 0:
          return 2.5;
        case 1:
        default:
          return 0;
      }
    } else {
      return 0;
    }
  }}%;
`;

const TVBackground = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

const tvBackgroundSwitcher = (tvType) => {
  switch (tvType) {
    case 1: return tvV2BackgroundSrc;
    case 0:
    default:
      return tvBackgroundSrc;
  }
};

const GenericBanner = ({
  banner: {
    top,
    left,
    right,
    bottom,
    width,
    height,
    isTv,
    tvType,
    bannerAsset,
    translateX,
    translateY,
    skewX,
    skewY,
    rotateX,
    rotateY,
    scaleX,
    scaleY,
  },
  locale,
  isSafari,
}) => (
  <GenericBannerContainer
    top={top}
    left={left}
    right={right}
    bottom={bottom}
    width={width}
    height={height}
    skewX={skewX}
    skewY={skewY}
    isTv={isTv}
    tvType={tvType}
    rotateX={rotateX}
    rotateY={rotateY}
    translateX={translateX}
    translateY={translateY}
    scaleX={scaleX}
    scaleY={scaleY}
    isSafari={isSafari}
  >
    {isTv && <TVBackground src={tvBackgroundSwitcher(tvType)} />}
    <SliderContainer tvType={tvType} isTv={isTv}>
      <BannerCarousel banners={bannerAsset} />
    </SliderContainer>
  </GenericBannerContainer>
);

GenericBanner.propTypes = {
  banner: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number,
    right: PropTypes.number,
    bottom: PropTypes.number,
    isTv: PropTypes.bool,
    tvType: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
    skewX: PropTypes.number,
    skewY: PropTypes.number,
    rotateY: PropTypes.number,
    bannerAsset: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    rotateX: PropTypes.number,
    scaleX: PropTypes.number,
    scaleY: PropTypes.number,
    translateX: PropTypes.number,
    translateY: PropTypes.number,
  }).isRequired,
  locale: PropTypes.string.isRequired,
  isSafari: PropTypes.bool,
};

GenericBanner.defaultProps = {
  isSafari: false,
};

export default GenericBanner;
